//* Libraries imports
import React from "react";

//* Components imports
import { ProcessEssayHeader } from "./process-essay-header";
import { ProcessEssayTable } from "./process-essay-table";
import { ProcessEssayPagination } from "./process-essay-pagination";

type EssayData = {
  id: number;
  title: string;
  statement: string;
  correctionStatus: "PENDENTE" | "CORRIGIDA";
}
type EssayField = {
  name: string;
  totalQuestions: string;
  header?: string;
  type?: string;
};

type ProcessEssayListProps = {
  title: string;
  pronoun?: string;
  searchPlaceholder?: string;
  notFoundMessage: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  onViewProcessExam?: (id: number) => void;
  onViewExamResults?: (id: number) => void;
  items: EssayData[];
  loading: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;  hideView?: boolean;
  hideResults?: boolean;
  fields: EssayField[];
  additionalButtons?: Array<{
    label: string;
    eventHandler: (e: React.MouseEvent) => void;
  }>;

  currentPage?: number;
  totalPages?: number;
  totalItems?: number;
  itemsPerPage?: number;
  onPageChange?: (page: number) => void;
};

export function ProcessEssayList({
  title,
  pronoun = "as",
  searchPlaceholder = "Pesquisar...",
  notFoundMessage,
  searchTerm,
  onSearchChange,
  onSearch,
  onViewProcessExam,
  onViewExamResults,
  items,
  loading,
  hideEdit = false,
  hideDelete = false,
  hideResults = false,
  hideView = false,
  fields,
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
}: ProcessEssayListProps) {
  
  // Sort items to show corrected essays first
  const sortedItems = React.useMemo(() => {
    if (!items || items.length === 0) return items;
    
    return [...items].sort((a, b) => {
      // CORRIGIDA items first, then PENDENTE
      if (a.correctionStatus === "CORRIGIDA" && b.correctionStatus === "PENDENTE") {
        return -1;
      }
      if (a.correctionStatus === "PENDENTE" && b.correctionStatus === "CORRIGIDA") {
        return 1;
      }
      return 0;
    });
  }, [items]);

  return (
    <div className="container bg-white p-4 rounded-3 shadow-sm">      
    {/* Header */}
      <ProcessEssayHeader
        title={title}
        pronoun={pronoun}
        searchTerm={searchTerm}
        searchPlaceholder={searchPlaceholder}
        onSearchChange={onSearchChange}
        onSearch={onSearch}
      />      {/* Table */}
      <div className="mt-4">
        <ProcessEssayTable
          items={sortedItems}
          loading={loading}
          notFoundMessage={notFoundMessage}
          onViewResult={onViewProcessExam}
          onViewExamResults={onViewExamResults}
          hideEdit={hideEdit}
          hideDelete={hideDelete}
          hideView={hideView}
          hideResults={hideResults}
          fields={fields}
        />
      </div>

      {/* Pagination */}
      {onPageChange && totalPages > 1 && (
        <ProcessEssayPagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
}
